/**
 * How many single-character edits turn `a` into `b`: an insertion, a deletion, a substitution or
 * swapping two neighbouring letters each count as one (optimal string alignment). Letter case is
 * ignored, so a capitalised suggestion is as close as its lower-case twin. A swap counts as one
 * because "thier" for "their" is the commonest typo there is.
 */
export function editDistance(a: string, b: string): number {
  const left = [...a.toLowerCase()]
  const right = [...b.toLowerCase()]
  let beforePrevious: number[] = []
  let previous = Array.from({ length: right.length + 1 }, (_, j) => j)

  for (let i = 1; i <= left.length; i++) {
    const current = [i]

    for (let j = 1; j <= right.length; j++) {
      const cost = left[i - 1] === right[j - 1] ? 0 : 1

      current[j] = Math.min(previous[j] + 1, current[j - 1] + 1, previous[j - 1] + cost)

      if (i > 1 && j > 1 && left[i - 1] === right[j - 2] && left[i - 2] === right[j - 1]) {
        current[j] = Math.min(current[j], beforePrevious[j - 2] + 1)
      }
    }

    beforePrevious = previous
    previous = current
  }

  return previous[right.length]
}
